import { create } from "zustand"

export type FleetScope = "all" | "my"

interface FleetFilterStore {
  scope: FleetScope
  setScope: (scope: FleetScope) => void
}

export const useFleetFilterStore = create<FleetFilterStore>((set) => ({
  scope: "all",
  setScope: (scope) => set({ scope }),
}))
